<template>
    <div class="item-pic">
        <shared-lazy-image :alt="title" :src="firstJpgRegular.url" class="item-img">
            <source type="image/webp" :srcset="`${firstWebpSmall.url} 1x, ${firstWebpRegular.url} 2x`" />
            <source :srcset="`${firstJpgSmall.url} 1x, ${firstJpgRegular.url} 2x`" />
        </shared-lazy-image>
        <shared-lazy-image
            v-if="hasSecondThumbnail && allowHoverImageLoading"
            :alt="title"
            :src="secondJpgRegular.url"
            class="item-img hover"
        >
            <source type="image/webp" :srcset="`${secondWebpSmall.url} 1x, ${secondWebRegular.url} 2x`" />
            <source :srcset="`${secondJpgSmall.url} 1x, ${secondJpgRegular.url} 2x`" />
        </shared-lazy-image>
        <shared-lazy-image v-else :alt="title" :src="firstJpgRegular.url" class="item-img hover">
            <source type="image/webp" :srcset="`${firstWebpSmall.url} 1x, ${firstWebpRegular.url} 2x`" />
            <source :srcset="`${firstJpgSmall.url} 1x, ${firstJpgRegular.url} 2x`" />
        </shared-lazy-image>
        <!-- <picture v-if="hasStUniv2Sticker">
            <img class="product-sticker-overlay-image" :data-src="stUniv2Url" :src="stUniv2Url" />
        </picture> -->
        <picture v-if="stickerImgUrl">
            <img
                class="product-sticker-overlay-image"
                :alt="stickerImgDescription"
                :data-src="stickerImgUrl"
                :src="stickerImgUrl"
            />
        </picture>
        <div class="message-panel success megaphone-icon" v-if="watchdogAvailable">
            <span v-html="watchdogMessage" class="pl-1"></span>
        </div>
    </div>
</template>

<script>
import collect from 'collect.js';
import { BREAKPOINT_MD } from '../../../constants';

export default {
    props: {
        coloredProduct: {},
        thumbnails: {},
        title: '',
        watchdogAvailable: null,
        watchdogMessage: null,
    },
    data() {
        return {
            breakpointTriggered: false,
            thumbnailsCollection: collect(this.thumbnails),
        };
    },
    computed: {
        allowHoverImageLoading() {
            /**
             * Only allow hover image to load when necessary since image hover
             * for screen sizes smaller than BREAKPOINT_MD is disabled in CSS
             */
            if (this.$screen.width >= BREAKPOINT_MD) {
                this.breakpointTriggered = true;
            }

            return this.breakpointTriggered;
        },
      //   hasStUniv2Sticker() {
      //       return this.coloredProduct.stUniv2Url != null;
      //   },
      //   stUniv2Url() {
      //       return this.coloredProduct.stUniv2Url;
      //   },
        sticker() {
			  return collect(this.coloredProduct.cms_stickers).where('show_as_image', 1).whereNotNull('url').sortByDesc('id').first();
        },
        stickerImgDescription() {
            return this.sticker?.current_lang_translation?.title || '';
        },
        stickerImgUrl() {
            return this.sticker?.url;
        },
        hasSecondThumbnail() {
            return this.secondJpgRegular != null;
        },
        firstJpgRegular() {
            return this.thumbnailsCollection
                .where('rank', 1)
                .where('type', 'product-list-regular')
                .where('format', 'jpg')
                .first();
        },
        secondJpgRegular() {
            return this.thumbnailsCollection
                .where('rank', '>', 1)
                .where('type', 'product-list-regular')
                .where('format', 'jpg')
                .first();
        },
        firstWebpRegular() {
            return this.thumbnailsCollection
                .where('rank', 1)
                .where('type', 'product-list-regular')
                .where('format', 'webp')
                .first();
        },
        secondWebRegular() {
            return this.thumbnailsCollection
                .where('rank', '>', 1)
                .where('type', 'product-list-regular')
                .where('format', 'webp')
                .first();
        },
        firstJpgSmall() {
            return this.thumbnailsCollection.where('rank', 1).where('type', 'product-list-small').where('format', 'jpg').first();
        },
        secondJpgSmall() {
            return this.thumbnailsCollection
                .where('rank', '>', 1)
                .where('type', 'product-list-small')
                .where('format', 'webp')
                .first();
        },
        firstWebpSmall() {
            return this.thumbnailsCollection.where('rank', 1).where('type', 'product-list-small').where('format', 'webp').first();
        },
        secondWebpSmall() {
            return this.thumbnailsCollection
                .where('rank', '>', 1)
                .where('type', 'product-list-small')
                .where('format', 'webp')
                .first();
        },
    },
};
</script>

<style lang="scss" scoped>
.coloredProducts--search .item-pic {
    margin: 0 !important;
}
</style>
